import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IDocumentReferenceProductDTO } from '@core/model';
import { ShellService } from '@mynexus/mfe-core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SharedDocumentReferencesService {
  protected readonly API_URL: string;
  protected readonly TENANT_ID: string;

  constructor(
    protected readonly http: HttpClient,
    shellService: ShellService,
    @Inject('stream') stream: string
  ) {
    this.API_URL = shellService.getBaseUrlFor(stream);
    this.TENANT_ID = shellService.getTenantId();
  }

  getDocumentReferences(
    lineOfBusinessId: string,
    reference: string
  ): Observable<IDocumentReferenceProductDTO[]> {
    return this.http.get<IDocumentReferenceProductDTO[]>(
      `${this.API_URL}/tenants/${this.TENANT_ID}/lob/${lineOfBusinessId}/DocumentReferences?reference=${reference}`
    );
  }

 getUploadMessage(authorizationNumber: string, isExternal: boolean) : { severity: string; summary: string; detail: string;}
   {
    return null;
  }
}


